import React from "react";
import { Link, Navigate } from "react-router-dom";
import { AlertTriangle, CreditCard, LogOut } from "lucide-react";
import { useTenant } from "../../context/TenantContext";

const SubscriptionBlocked: React.FC = () => {
  const { tenant } = useTenant();
  const token = localStorage.getItem("token");
  const role = (localStorage.getItem("role") || "").toLowerCase();
  const blockedReason = localStorage.getItem("subscriptionBlockedReason") || "expired";
  const blockedMessage = localStorage.getItem("subscriptionBlockedMessage") || "Your school subscription has expired.";

  if (!token) {
    return <Navigate to="/signin" replace />;
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <div className="w-full max-w-2xl rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/50 p-8 md:p-10">
        <div className="w-16 h-16 rounded-2xl bg-rose-50 flex items-center justify-center mb-6">
          <AlertTriangle className="text-rose-600" size={30} />
        </div>
        <p className="text-xs font-black uppercase tracking-[0.28em] text-slate-400 mb-3">Access Restricted</p>
        <h1 className="text-3xl font-black tracking-tight text-slate-950 mb-4">
          {blockedReason === "suspended" ? "School Access Suspended" : "Subscription Expired"}
        </h1>
        <p className="text-base text-slate-600 leading-7">
          {blockedMessage}
        </p>
        <p className="text-sm text-slate-500 mt-4">
          {tenant?.name ? `${tenant.name} is currently limited to billing review access only.` : "This tenant is currently limited to billing review access only."}
        </p>

        <div className="mt-8 flex flex-wrap gap-3">
          {role === "admin" && blockedReason !== "suspended" && (
            <Link to="/settings/subscription" className="inline-flex items-center gap-2 rounded-2xl bg-slate-900 text-white px-5 py-3 text-sm font-semibold">
              <CreditCard size={16} />
              Go to Subscription Page
            </Link>
          )}
          <Link
            to="/signin"
            onClick={() => {
              localStorage.removeItem("token");
              localStorage.removeItem("userName");
              localStorage.removeItem("role");
              localStorage.removeItem("profilePicture");
              localStorage.removeItem("userTitle");
              localStorage.removeItem("userId");
              localStorage.removeItem("subscriptionBlocked");
              localStorage.removeItem("subscriptionBlockedReason");
              localStorage.removeItem("subscriptionBlockedMessage");
            }}
            className="inline-flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-5 py-3 text-sm font-semibold text-slate-700"
          >
            <LogOut size={16} />
            Sign Out
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionBlocked;
